import React, {useState} from 'react';

import lang from '../../../lang/lang';

import { TodoAddInputStyled } from './TodoAppInput.styled';

const TodoAddInput = (props) => {
    const [langState, setLangState] = useState(localStorage.getItem('language') || 'en')

    return <>
        <TodoAddInputStyled
            type={props.type}
            value={props.value}
            onInput={props.onInput}
            placeholder={langState === 'uk' ? lang.uk.todoInputPlaceHolder : lang.en.todoInputPlaceHolder}
            onKeyDown={props.onKeyDown}
        />
    </>
};

export default TodoAddInput;